import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import User from '../Asset/app/media/img/users/user.png';
import NexdmImg from '../Asset/app/media/img//logos/nexdigm-logo.png';
import './NavMenu.css';
import axios from 'axios';
import global from './global';
import Dropdown from 'react-bootstrap/Dropdown';
import { config } from '../Constants';
import { Button, Navbar, NavDropdown, Nav, DropdownButton } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
        Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import { Row, Col, InputGroup, FormControl } from 'react-bootstrap';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            role: '',
            token: '',
            DPID: '',
            URL: '',
            uniqueCode: '',
            UserName: '',
            EmailID: '',
            LastLoginTime: '',
            IsLogin: 0,
            time: {}, seconds: 900, showsignmodal: false

        };

        axios.get(global.UserManagement.GetSessionDetailsAPI)
            .then(response => {
                if (response.data.Status) {
                    this.setState({
                        UserName: response.data.UserName,
                        EmailID: response.data.EmailID,
                        IsLogin: response.data.IsLogin,
                        DPID: response.data.DPID,
                        URL: config.url.Web_URL
                    });


                    console.log(response.data.IsLogin);
                    console.log(this.state.IsLogin);

                }
                
            })
            .catch(error => {
                console.log(error);
            });

        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
    }

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    startTimer() {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }

    }

    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds == 0) {
            clearInterval(this.timer);
            this.setState({ showsignmodal: true });
            
        }
    }
    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }
    componentDidMount() {
        this.timer = setInterval(this.countDown, 1000);
        this.setState({ loading: false, time: {}, seconds: 1800});
    }

     
    handleRedirect = (e) => {
        e.preventDefault();
        var url = config.url.Web_URL;
        window.location.href = url + '/SignIn';
    }

    handleLogout = (e) => {
        axios.post(global.UserManagement.LogoutAPI)
        .then(json => {
            if (json.data.status) {  
                sessionStorage.clear(); //for sessionStorage
                window.location.href = this.state.URL;
            }
        })
        this.setState(this.initialState)
    }

    render() {
        return (
            <div>
            <Modal isOpen={this.state.showsignmodal} size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <ModalBody>
                        <Row>
                            <Col md={12} className="session-modal-text">
                            Session Expired. Kindly Relogin
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-success" type="button" onClick={this.handleRedirect}>GO TO LOGIN</button>
                </ModalFooter>
                         
                </Modal>
                <header id="m_header" className="m-grid__item    m-header " m-minimize-offset="200" m-minimize-mobile-offset="200" >
                    <div className="m-container m-container--fluid m-container--full-height">
                        <div className="m-stack m-stack--ver m-stack--desktop">
                            <div className="m-stack__item m-brand  m-brand--skin-dark ">
                                <div className="m-stack m-stack--ver m-stack--general">
                                    <div className="m-stack__item m-stack__item--middle m-brand__logo">
                                        <a href="#" className="m-brand__logo-wrapper_text">
                                            Easy Dividend
                                            {/*<img alt="" src={process.env.PUBLIC_URL + "/Images/nexdigm-logo-sm.png"} />*/}
                                        </a>
                                    </div>
                                    <div className="m-stack__item m-stack__item--middle m-brand__tools">
                                        <a id="m_aside_header_topbar_mobile_toggle" href="#" className="m-brand__icon m--visible-tablet-and-mobile-inline-block">
                                            <i className="flaticon-more"></i>
                                        </a>
                                    </div>




                                </div>
                            </div>
                            <div className="m-stack__item m-stack__item--fluid m-header-head" id="m_header_nav">
                                <button className="m-aside-header-menu-mobile-close  m-aside-header-menu-mobile-close--skin-dark " id="m_aside_header_menu_mobile_close_btn">
                                    <i className="la la-close"></i>
                                </button>


                                <div id="m_header_menu" className="m-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas  m-header-menu--skin-light m-header-menu--submenu-skin-light m-aside-header-menu-mobile--skin-dark m-aside-header-menu-mobile--submenu-skin-dark "  >
                                </div>
                                <div id="m_header_topbar" className="m-topbar  m-stack m-stack--ver m-stack--general">

                                    <span className="TimerText"><i className="text-white m-nav__link-icon fa fa-clock-o m-l-10 m-r-10"></i>Timeout: {this.state.time.m} : {this.state.time.s}</span> 


                                    <div className="m-stack__item m-topbar__nav-wrapper">
                                        <ul className="m-topbar__nav m-nav m-nav--inline">
                                            <li className="m-nav__item m-topbar__user-profile m-topbar__user-profile--img m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light" m-dropdown-toggle="click" aria-expanded="true">
                                                <a className="m-nav__link m-dropdown__toggle">
                                                    <span className="m-topbar__userpic">
                                                        <img src={process.env.PUBLIC_URL + "/Images/user.png"} className="m--img-centered" alt="" />
                                                    </span>
                                                        <span className="m-topbar__username">
                                                        <span className="name"><strong>{this.state.UserName}</strong></span>
                                                        <span className="email">{this.state.EmailID}</span>
                                                        </span>
                                                        <i className="m-menu__hor-arrow la la-angle-down"></i>
                                                </a>
                                                    <div className="m-dropdown__wrapper">
                                                        <span className="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust" ></span>
                                                        <div className="m-dropdown__inner">
                                                            <div className="m-dropdown__body">
                                                                <div className="m-dropdown__content">
                                                                    <ul className="m-nav m-nav--skin-light">
                                                                        <li className="m-nav__item" style={{ display: `${this.state.IsLogin == null ? 'none' : 'block'}` }}>
                                                                            <a href="#" className="m-nav__link">
                                                                                <i className="m-nav__link-icon fa fa-clock-o"></i>
                                                                                <span className="m-nav__link-text">
                                                                                Last Login Time: <span className="link-time">{this.state.LastLoginTime}</span>
                                                                                </span>
                                                                            </a>
                                                                        </li>
                                                                        <li className="m-nav__item">
                                                                        <a href={process.env.PUBLIC_URL + "/Templates/Easy-Dividend-User-Manual.pdf"} download="Easy-Dividend-User-Manual.pdf" className="m-nav__link">
                                                                                <i className="m-nav__link-icon fa fa-info-circle"></i>
                                                                                <span className="m-nav__link-text">
                                                                                    Easy Dividend User Manual
                                                                                </span>
                                                                            </a>
                                                                        </li>
                                                                        <li className="m-nav__item" style={{ display: `${this.state.IsLogin == null ? 'none' : 'block'}` }}>
                                                                            <a onClick={this.handleLogout} className="m-nav__link">
                                                                            <i className="m-nav__link-icon fa fa-sign-out"></i>
                                                                                    <span className="m-nav__link-text">
                                                                                        Logout
                                                                                    </span>
                                                                                </a>
                                                                        </li>
                                                                    <li className="m-nav__item" style={{ display: `${this.state.IsLogin == null ? 'block' : 'none'}` }}>
                                                                            <a onClick={this.handleLogout} className="m-nav__link">
                                                                            <i className="m-nav__link-icon fa fa-sign-out"></i>
                                                                                <span className="m-nav__link-text">
                                                                                    Exit
                                                                                </span>
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                 </li>
                                              </ul>
                                           </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
            </div>
        );
    }
}
